import * as yup from 'yup';

export const nameSchema = yup
  .string()
  .max(255, 'Name cannot be longer than 255 characters')
  .test('validate name', 'Please enter a full name', (value) => {
    return /^[^ ]+( [^ ]+)+$/.test(value?.trim());
  })
  .required('Please enter a full name');

const schema = () =>
  yup.object().shape({
    name: nameSchema,
    email: yup.string().email().required('Please enter a valid email'),
    password: yup.string().min(6, 'Minimum password is 6 character').nullable(),
    passwordConfirmation: yup
      .string()
      .test('passwords-match', 'Passwords must match', function (value) {
        return this.parent.password === value;
      }),
  });

export default schema;
